import { Stack, StackProps, Typography } from "@mui/material";
import { useIsMobile } from "src/hooks/useIsMobile";
import MonitorWeightIcon from "@mui/icons-material/MonitorWeight";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

type Props = {
  category: string;
  showHSAFSA?: boolean;
  title?: string;
} & StackProps;

const HSAFSADisclaimer = ({ category, showHSAFSA, title, ...props }: Props) => {
  const isMobile = useIsMobile();
  const dip = 14;
  const page = "payment-information";
  const { t } = useTranslation();

  const productCategory = useMemo(() => {
    return t(`product-category.${category}`);
  }, [category, t]);

  const disclaimer = useMemo(() => {
    if (showHSAFSA) {
      return t(`${page}.hsaDisclaimer`);
    }

    if (title != null) {
      return title;
    }

    if (["Erectile Dysfunction", "Mental Health"].includes(category)) {
      return t(`${page}.${category}.disclaimer`, {
        category: productCategory,
      });
    }

    return t(`${page}.disclaimer`, { category: productCategory });
  }, [category, productCategory, showHSAFSA, t, title]);

  return (
    <Stack
      {...props}
      direction="row"
      sx={{
        position: "relative",
        p: 2,
        pb: 3,
        backgroundColor: "#00B6B8",
        borderRadius: "10px 10px 0 0",
        overflow: "visible",
        zIndex: 1000,
        "&:after": {
          content: "''",
          position: "absolute",
          bottom: `-1px`,
          left: 0,
          width: "100%",
          height: `${dip + 1}px`, // how deep your curve is
          backgroundColor: "#ffffff",

          borderTopLeftRadius: "20% 40px",
          borderTopRightRadius: "20% 40px",
        },
      }}
      gap={1}
      justifyContent="center"
      alignItems="center"
    >
      {showHSAFSA ? (
        <AttachMoneyIcon
          sx={{ background: "#ffffff", borderRadius: "5px" }}
          color="primary"
        />
      ) : category === "Weight Loss" ? (
        <MonitorWeightIcon
          fontSize={isMobile ? "medium" : "large"}
          sx={{
            color: "#ffffff",
            padding: "2px",
          }}
        />
      ) : null}
      <Typography variant={isMobile ? "body1" : "h6"} color="#ffffff">
        {disclaimer}
      </Typography>
    </Stack>
  );
};

export default HSAFSADisclaimer;
